import { Empty } from "../../components/Empty.js";

const BYTESPIKE_CONSOLE_URL = "https://console.bytespike.ai";

/**
 * 用量与费用 — 不重复造轮子（2026-07-03 拍板）：DOSIA 桌面端已有全员用量榜，
 * 网关侧 ByteSpike 控制台有权威的按模型/按日用量与费用，这里一键跳转。
 */
export function UsagePanel(): JSX.Element {
  return (
    <Empty
      title="用量与费用在 ByteSpike 控制台查看"
      description="按成员 / 模型 / 日期的用量与费用明细以网关侧数据为准；DOSIA 桌面端管理员视角也有全员用量榜"
      action={
        <a
          href={BYTESPIKE_CONSOLE_URL}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center rounded bg-dosia-accent px-4 py-2 text-sm font-medium text-dosia-bg-light hover:bg-dosia-accent-hover"
        >
          打开 ByteSpike 控制台 ↗
        </a>
      }
    />
  );
}
